module.exports = __webpack_public_path__ + "static/media/blanda.6fa3b68d.mp3";